import { SxProps, Theme } from '@mui/material';

export const orderItemTableQuantitySX: SxProps<Theme> = () => ({
	'.MuiSvgIcon-root': {
		'&:hover': {
			color: 'primary.main',
		},
	},
	gap: '5px',
});
